import type { CSSProperties } from 'react';

import classnames from 'classnames';

import { BackActionButton } from './components/BackActionButton';
import { CommentActionButton } from './components/CommentActionButton';
import { LikeActionButton } from './components/LikeActionButton';
import { ShareActionButton } from './components/ShareActionButton';

import type { PostActionsElementProps } from './PostActions.types';

export function PostActionsElement(props: PostActionsElementProps) {
  const { element, children, attributes, onBackClick, onCommentClick, translations, showCommentsButton } = props;

  const {
    mobile_hide,
    desktop_hide,
    margin,
    padding,
    shadow,
    borderRadius,
    borderWidth,
    borderBottomWidth,
    borderColor,
    borderStyle,
    background,
    buttonColor,
    buttonBackgroundColor,
    hoverButtonColor,
    hoverButtonBackgroundColor,
  } = element.attrs || {};

  const { data } = element.attrs;

  return (
    <div
      className={classnames('flex flex-row justify-center relative w-screen')}
      style={
        {
          margin,
          padding,
          boxShadow: shadow,
          borderWidth,
          borderBottomWidth,
          borderColor,
          borderStyle,
          borderRadius,
          background,
          '--button-color': buttonColor,
          '--button-background-color': buttonBackgroundColor,
          '--hover-button-color': hoverButtonColor,
          '--hover-button-background-color': hoverButtonBackgroundColor,
        } as CSSProperties
      }
      {...attributes}
    >
      <div
        id="post-actions-container"
        className={classnames(
          {
            'mobile:hidden': mobile_hide,
            'desktop:hidden': desktop_hide,
          },
          'flex flex-row justify-between items-center',
        )}
        style={
          {
            width: '100%',
            maxWidth: 468,
          } as CSSProperties
        }
      >
        <BackActionButton onClick={onBackClick} translations={translations} />

        <LikeActionButton data={data} translations={translations} />

        {showCommentsButton && <CommentActionButton onClick={onCommentClick} translations={translations} data={data} />}

        <ShareActionButton data={data.share} translations={translations} />
      </div>

      {children}
    </div>
  );
}
